import { Box, BoxProps, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { VoiceBoxModule } from 'mportal-module'
import { useWindowDimensions } from 'react-native'
import { SvgImage } from '../../../comps/SvgImage'

const VoiceboxBTItem = ({ data, mid }) => {
  const { btDevices } = data
  const subtitle = btDevices.length === 1 ? btDevices[0] : `${btDevices[0]} and ${btDevices.length - 1} more`
  const width = useWindowDimensions().width
  const showDeviceRequest = () => {
    VoiceBoxModule.showDeviceList(mid, data.dsn)
  }
  return (
    <Box {...styles.container(width)}>
      <Box flex={1} flexDirection={'row'} alignItems={'center'}>
        <SvgImage imageName="BluetoothIcon" height={36} width={36} />
        <Spacer size={12} direction="horizontal" />
        <Box>
          <Text fontSize={14} color={'WHITE'} fontFamily="JioType-Bold">
            Bluetooth pair request
          </Text>
          <Text fontSize={12} color={'WHITE'} fontFamily="JioType-Medium">
            {subtitle}
          </Text>
        </Box>
      </Box>
      <Box onPress={showDeviceRequest} underlayColor={'GRAY_BORDER'} padding={8}>
        <Text fontSize={14} color={'#F2BE75' as ColorOptions} fontFamily="JioType-Bold">
          View All
        </Text>
      </Box>
    </Box>
  )
}

const styles = {
  container: (width) =>
    ({
      height: 66,
      width: width - 48,
      borderRadius: 16,
      padding: 16,
      marginRight: 12,
      alignItems: 'center',
      flexDirection: 'row',
      backgroundColor: '#0000000D' as ColorOptions,
    } as BoxProps),
}

export { VoiceboxBTItem }
